import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	accoInfoContentWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.medium,
		backgroundColor: theme.palette.neutral[5],
		paddingBottom: theme.spacing.medium,

		[getFromBreakpoint('md')]: {
			padding: `${theme.spacing.xxlarge} 0`,
		},
	},
	accoInfoContent: {
		[getFromBreakpoint('md')]: {
			minWidth: theme.section.width.lg,
			margin: '0 auto',
		},
	},
	wave: {
		width: '100%',
		display: 'block',
		transform: 'scaleX(-1)',
	},
}));
